import Const from 'constants';
import {generateSignature, generateRandomKey} from 'helpers/hash';

class StackItem {
    constructor() {
        this._id = generateRandomKey();
        this._exposure = {exactly: 0};
        this._competitionId = '';
        this._opponentIds = [];
    }
    getId() {
        return this._id;
    }
    getCompetitionId() {
        return this._competitionId;
    }
    getOpponentIds() {
        return this._opponentIds;
    }
    getExposure() {
        return Number(this._exposure.exactly);
    }
}

const stackItem = new StackItem();

const defaultState = {
    data: {
        stackItems: {
            [stackItem.getId()]: stackItem,
        },
    },
    enabled: false,
    signature: null,
    competitionType: '',
    all() {
        return {...this.data};
    },
    isEnabled() {
        return Boolean(this.enabled);
    },
    getItems() {
        return this.data.stackItems;
    },
    hasItems() {
        return !isEmpty(this.data.stackItems);
    },
    getItemById(itemId) {
        return this.data.stackItems[itemId];
    },
    getOpponentIdsByCompetitionId(competitionId) {
        for (let stackItem of Object.values(this.getItems())) {
            if (stackItem.getCompetitionId() === competitionId) {
                return stackItem.getOpponentIds();
            }
        }
        return [];
    },
    getSignature() {
        return this.signature;
    },
    getCompetitionType() {
        return this.competitionType;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.COMPETITION_STACKING_SET_IS_USED) {
        state.enabled = Boolean(action.use);
        state.competitionType = action.competitionType;
    } else if (action.type === Const.COMPETITION_STACKING_ADD_ITEM) {
        const stackItem = new StackItem();
        state.data.stackItems[stackItem.getId()] = stackItem;
    } else if (action.type === Const.COMPETITION_STACKING_SET_COMPETITION) {
        const {itemId, competition} = action;
        const stackItem = state.getItemById(itemId);
        stackItem._competitionId = competition.competitionId;
        stackItem._opponentIds = [...competition.opponentIds];
    } else if (action.type === Const.COMPETITION_STACKING_SET_EXPOSURE) {
        const stackItem = state.getItemById(action.itemId);
        stackItem._exposure.exactly = action.value;
    } else if (action.type === Const.COMPETITION_STACKING_REMOVE_ITEM) {
        delete state.data.stackItems[action.itemId];
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        const stackItem = new StackItem();

        state = {
            ...defaultState,
            data: {
                stackItems: {
                    [stackItem.getId()]: stackItem,
                },
            },
            enabled: false,
            signature: generateSignature(),
        };
    }

    return state;
}
